import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VerificationComponent } from './verification.component';
import { VerificationRoutingModule } from './verification-routing';
import { SharedModule } from '../../shared/shared.module';



@NgModule({ declarations: [
        VerificationComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        VerificationRoutingModule,
        SharedModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class VerificationModule { }
